<template>
<div class="section-layout">
  <template v-if="layout === 'splitLayout'">
    <layout-split :group="group" :pageData="pageData"></layout-split>
  </template>

  <template v-else-if="layout === 'horizontal'">
    <layout-horizontal :group="group" :pageData="pageData"></layout-horizontal>
  </template>

  <template v-else-if="layout === 'occupants'">
    <layout-occupants :group="group" :pageData="pageData" :sectionTitles="sectionTitles"></layout-occupants>
  </template>
  <template v-else-if="layout === 'coverage'">
    <layout-coverage :group="group" :pageData="pageData" :pageSection="pageSection" ></layout-coverage>
  </template>
  <template v-else-if="layout === 'mortgage'">
    <layout-mortgage :group="group" :pageData="pageData" :pageSection="pageSection" ></layout-mortgage>
  </template>
  <template v-else-if="layout === 'hopolicydetails'">
    <layout-hopolicy-details :group="group" :pageData="pageData" :pageSection="pageSection" ></layout-hopolicy-details>
  </template>
  <template v-else>
    <layout-default :group="group" :pageData="pageData"></layout-default>
  </template>
</div>
</template>

<script>
/* eslint-disable */
import LayoutMortgage from '@/components/presentational/layouts/LayoutMortgage';
import LayoutHorizontal from '@/components/presentational/layouts/LayoutHorizontal';
import LayoutSplit from '@/components/presentational/layouts/LayoutSplit';
import LayoutDefault from '@/components/presentational/layouts/LayoutDefault';
import LayoutCoverage from '@/components/presentational/layouts/LayoutCoverage';
import LayoutOccupants from '@/components/presentational/layouts/LayoutOccupants';
import EventBus from '../interview/shared/interview-event-bus';
import LayoutHopolicyDetails from '@/components/presentational/layouts/LayoutHopolicyDetails';

export default {
  props: ['group', 'pageData', 'pageSection'],
  inject: ['$validator'],
  data() {
    return {
      sections: [],
      subSections: [],
      subSubSections: [],
      layout: null,
      sectionTitles: [],
    };
  },
  components: {
    LayoutHorizontal,
    LayoutSplit,
    LayoutDefault,
    LayoutOccupants,
    LayoutCoverage,
    LayoutMortgage,
    LayoutHopolicyDetails
  },
  methods: {
    removeNotNeededGroups(sectionsToRetain) {
      let allSections = Object.keys(this.group);
      let sectionsTobeRemoved= allSections.filter(section=>{
        if(!sectionsToRetain.includes(section))
          return section;
      })
      sectionsTobeRemoved.forEach((element) => {
       delete this.group[element];
      });
    },
    chooseLayout() {
      let sectionName = (this.pageData ? this.pageData.page_name : 'untitled');
       if(sessionStorage.getItem("setRc2NavFlowAction") === 'true'){
          sectionName=this.$store.getters.homeRc2Nav.page_name;
         this.removeNotNeededGroups(this.pageSection);
        }
       
       switch (sectionName) { // TODO: Use config values
        case 'NamedInsured':
        case 'HONamedInsured':
        case 'CONamedInsured':
        case 'RENamedInsured':
          this.layout = 'splitLayout';
          break;

        case 'HOOccupants':
        case 'COOccupants':
        case 'REOccupants':
          this.layout = 'occupants';

          this.sectionTitles = [ // TODO: Use config values
            [
              0,
              1,
            ],
            [
              2,
            ],
          ];
          break;
          case 'hocoverage':
          this.layout = 'coverage'; 
          break;
          case 'homortgage':
          this.layout = 'mortgage'; 
          break;
           case 'hopolicydetails':
          this.layout = 'hopolicydetails'; 
          break;
          
        default:
          break;
      }
    },
  },
  created() {
    this.chooseLayout(); // Choose layout initially (and the watched properties will update thereafter)
  },
  watch: {
    pageData: function pageData(newValue) {
      window.console.info('pageData changed', this.pageData, newValue);
      this.chooseLayout();
    },
    group: function group(newValue) {
      window.console.info('group changed', newValue);
      this.chooseLayout();
    },
  },
  mounted() {
    EventBus.$emit('refresh-header');
  },
};
</script>
<style>
.vd-btn.list-item .delete{
    display: inline-block;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    line-height: 1em;
    cursor: pointer;
}
.list-item{
    display: inline-block;
    width: auto;
    height: auto;
    min-height: auto;
    float: none;
    margin: 0.25rem
}
.add-button{
    text-transform: initial;
}
</style>




// WEBPACK FOOTER //
// src/components/presentational/SectionLayout.vue?ad29c4dc